export { default as YourDetailsDrawer } from './your-details';
